enum CollectableType {
    SCREENSHOT= 'SCREENSHOT',
    BOOKMARK= 'BOOKMARK',
    QUOTE= 'QUOTE',
    NOTE= 'NOTE'
  };

  export default CollectableType;